export abstract class NavigationHelper {

    public static isIframe(): boolean {
        try {
            return window.self !== window.top;
        } catch {
            return true;
        }
    }

    public static isReload(): boolean {
        try {
            const perf = window.performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
            if (perf) {
                return perf.type === 'reload';
            }
            // Fallback for older browsers
            return (window.performance as any).navigation.type === 1;
        } catch (e) {
            return false;
        }
    }
}
